import React, { useState, useEffect } from "react";
import { Button, Form, FormGroup, Label, Input } from "reactstrap";
import { fetchPublicationsForReport } from "./Axios";

const ReportForm = ({ reportType, onCreated, showNotification, disabled }) => {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [publications, setPublications] = useState([]);
  const [selectedPublication, setSelectedPublication] = useState("");
  const [format, setFormat] = useState("xlsx");

  useEffect(() => {
    if (reportType === "postulations") {
      fetchPublicationsForReport((res) => {
        if (res.status === 200) setPublications(res.data);
      });
    }
  }, [reportType]);

  const handleSubmit = (e) => {
    e.preventDefault();

    if ((reportType !== "postulations" || !selectedPublication) && (!startDate || !endDate)) {
      showNotification("Campos requeridos", "Debes ingresar un rango de fechas.", "danger");
      return;
    }

    const filters = {};

    if (reportType === "postulations" && selectedPublication) {
      const pub = publications.find(p => p.id === parseInt(selectedPublication, 10));
      filters.publication_id = selectedPublication;
      filters.publication_title = pub?.title || "";
    } else {
      filters.start_date = startDate;
      filters.end_date = endDate;
    }

    onCreated({ ...filters, format });
  };

  return (
    <Form inline onSubmit={handleSubmit}>
      {!(reportType === "postulations" && selectedPublication) && (
        <>
          <FormGroup className="mr-2">
            <Label className="mr-2">Desde</Label>
            <Input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
          </FormGroup>
          <FormGroup className="mr-2">
            <Label className="mr-2">Hasta</Label>
            <Input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
          </FormGroup>
        </>
      )}

      {reportType === "postulations" && (
        <FormGroup className="mr-2">
          <Label className="mr-2">Publicación</Label>
          <Input type="select" value={selectedPublication} onChange={(e) => setSelectedPublication(e.target.value)}>
            <option value="">Todas</option>
            {publications.map(p => (
              <option key={p.id} value={p.id}>{p.title}</option>
            ))}
          </Input>
        </FormGroup>
      )}

      <FormGroup className="mr-2">
        <Label className="mr-2">Formato</Label>
        <Input type="select" value={format} onChange={(e) => setFormat(e.target.value)}>
          <option value="xlsx">Excel (XLSX)</option>
          <option value="csv">CSV</option>
        </Input>
      </FormGroup>

      <Button type="submit" color="primary" disabled={disabled}>Generar</Button>
    </Form>
  );
};

export default ReportForm;
